import { picaResize, resizeAndCenterImage } from './resizeImage';

export const resizeAndCropToKeepAspect = [
  // Crop image to match requested aspect ratio
  async (canvas: HTMLCanvasElement, width: number, height: number) => {
    // Will find out which dimension is larger and use ratio to get width and height to form square dimensions.
    // Why not just pass in whichever is smaller of width or height?
    const ratio = Math.min(canvas.width / width, canvas.height / height);
    return resizeAndCenterImage(canvas, width * ratio, height * ratio);
  },
  // Resize using pica
  async (canvas: HTMLCanvasElement, width: number, height: number) => {
    return await picaResize(canvas, width, height);
  },
];
